var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dot-navigation-container flex items-center",
      class: { "primary-color": _vm.primaryColor }
    },
    [
      _c("div", { staticClass: "left-arrow", on: { click: _vm.prevPage } }, [
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.value > 1,
              expression: "value > 1"
            }
          ],
          attrs: {
            src: _vm.primaryColor
              ? "/imgs/icons/left-primary-arrow.webp"
              : "/imgs/icons/left-white-arrow.webp"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-grow" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dot-navigation" },
        _vm._l(_vm.pageCount, function(i) {
          return _c("div", {
            key: i,
            class: { active: i === _vm.value },
            on: {
              click: function($event) {
                _vm.$emit("input", i)
              }
            }
          })
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex-grow" }),
      _vm._v(" "),
      _c("div", { staticClass: "right-arrow", on: { click: _vm.nextPage } }, [
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.value < _vm.pageCount,
              expression: "value < pageCount"
            }
          ],
          attrs: {
            src: _vm.primaryColor
              ? "/imgs/icons/right-primary-arrow.webp"
              : "/imgs/icons/right-white-arrow.webp"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-de5215d4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de5215d4","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/DotNavigation.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-de5215d4","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/DotNavigation.vue
// module chunks = 1 2 3